import { AppConfig } from "@shared/constants/AppConfig";
import { RequestUrlBuilder } from "@shared/utils/requestUrlBuilder";

export class ApiPaths {
  private constructor() {}
  static Gateway = {
    redirectManager: ApiPaths.buildApiPath(
      AppConfig.ApiRoots.Gateway,
      "/redirect/manager",
    ),
    // ログアウトのエンドポイントは/v2が必要ないため除去
    logout: ApiPaths.buildApiPath(
      AppConfig.ApiRoots.Gateway,
      "/logout",
    ).replace("/v2", ""),
  };

  static Auth = {
    userInfo: ApiPaths.buildApiPath(AppConfig.ApiRoots.Auth, "/userinfo"),
    signout: ApiPaths.buildApiPath(AppConfig.ApiRoots.Auth, "/logout"),
    passwordChange: ApiPaths.buildApiPath(
      AppConfig.ApiRowRoots.Auth,
      "/auth/realms/bs-web-user/protocol/openid-connect/auth",
      {
        clientId: "manager",
        redirectUri: `${AppConfig.ApiRowRoots.Web}/manager`,
        responseType: "code",
        scope: "openid",
        kcAction: "UPDATE_PASSWORD",
      },
    ),
  };

  static Order = {
    detail: ApiPaths.buildApiPath(AppConfig.ApiRoots.Order, "/orders"),
  };

  /**
   * APIの完全な絶対パスを組み立てるユーティリティ関数
   * @param apiRoot - AppConfig.ApiRootsの値
   * @param path - 相対パス
   * @param params - クエリパラメータのオブジェクト
   * @returns 完全な絶対パス
   */
  static buildApiPath<T extends Record<string, unknown>>(
    apiRoot: (typeof AppConfig.ApiRoots)[keyof typeof AppConfig.ApiRoots],
    path: string,
    params?: T,
  ): string {
    return new RequestUrlBuilder(`${apiRoot}${path}`, params).build();
  }
}
